import { z } from "zod";
import { FalsyBool } from "@/lib/api/schemas/patterns";

export const CasePayload = z
  .string()
  .transform((v) => {
    try {
      const parsed = JSON.parse(v);

      const isVisual = parsed.project && parsed.test_case_data;

      const isApi = parsed.data !== undefined;

      if (isVisual) {
        return { type: "visual", ...parsed };
      }

      if (isApi) {
        return { type: "api", ...parsed };
      }

      throw new Error("Payload does not match visual or api case structure");
    } catch (error) {
      if (error instanceof Error && error.message.includes("does not match")) {
        throw error;
      }
      return null;
    }
  })
  .pipe(
    z.union([
      z.object({
        type: z.literal("visual"),
        project: z.object({
          id: z.number(),
          name: z.string(),
        }),
        test_case_data: z.object({
          // Expected result is optional — tests can run without one.
          expected_result: z.string().nullish(),
          instruction: z.string(),
          is_precondition: FalsyBool,
        }),
      }),
      z
        .object({
          type: z.literal("api"),
          data: z.string(),
        })
        .passthrough(),
    ]),
  );
